import request from "@/utils/request";

export function selectPageList(data) {
  return request({
    url: `/test/reportPhased/selectPageList`,
    method: "post",
    data: data,
  });
}

export function getTemplateFileUrl() {
  return request({
    url: `/test/reportPhased/getTemplateFileUrl`,
    method: "get",
  });
}

export function insertOne(data) {
  return request({
    url: `/test/reportPhased/insertOne`,
    method: "post",
    data: data,
  });
}

export function detailData(data) {
  return request({
    url: `/test/reportPhased/detail`,
    method: "post",
    data: data,
  });
}

export function deleteBatch(data) {
  return request({
    url: `/test/reportPhased/deleteBatch`,
    method: "post",
    data: data,
  });
}
